import styled from 'styled-components';

// The people pickers' text (PersonPickerModal): the description, the select's label and the message under it, with
// the spacing the Send for Approval page had (label 4px over the select, message 8px under it)
export const PickerDescriptionStyled = styled.p`
  margin: 0 0 12px;
`;

export const PickerLabelStyled = styled.span`
  display: block;
  margin-bottom: 4px;
  font-weight: 600;
  color: ${p => p.theme?.colors?.dark ?? '#1F2433'};
`;

export const PickerMessageStyled = styled.span`
  display: block;
  margin-top: 8px;
  color: ${p => p.theme?.colors?.gray ?? '#565E70'};
`;
